import { CareerId } from '@common/const/catalog/career';
import { SxProps, styled } from '@cp/ds';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import React, { ComponentType } from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks';
import { Stack } from '@cp/ds/src/components/stack';
import { BannerServiceFeatureBody } from '@cp/entities/catalog';
import { Image as Img } from '@cp/ui';
import { getAssetSrc, toAsset } from '@cp/shared/image';
import { CatalogRoutedButton } from 'src/features/catalog';
import stubAvatars from './assets/stub-avatars.png';

const Root = styled(Box, { name: 'BannerServiceFeature' })({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  textAlign: 'center',
}) as unknown as ComponentType<BoxProps>;

export interface BannerServiceFeatureProps {
  header?: React.ReactNode;
  sx?: SxProps;
}
export const BannerServiceFeature: React.FC<BannerServiceFeatureProps> = ({ header, ...props }) => {
  const theme = useTheme();

  return (
    <Root {...props}>
      {header}
      <BannerServiceFeatureBody
        columnsContent={[
          {
            c: (
              <Stack sx={{ alignItems: 'center' }}>
                <Img alt="" src={getAssetSrc(toAsset(stubAvatars))} sx={{}} />
                <CatalogRoutedButton size="small" sx={{ mt: 2.5 }}>
                  Найти помощника
                </CatalogRoutedButton>
              </Stack>
            ),
          },
          {
            c: (
              <>
                <Typography variant="h2">
                  {'👍🏻 97% '}
                  <Typography variant="button">Положительных отзывов</Typography>
                </Typography>
                <Typography component="p" sx={{ color: theme.palette.text.secondary, m: '8px 0' }}>
                  1000 отзывов оставили семьи за последние 12 месяцев.
                  <br /> Из них 970 - положительные.
                </Typography>
              </>
            ),
          },
          {
            c: (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography>
                    <Typography sx={{ color: theme.palette['brand pink'] }} variant="h2">
                      You
                    </Typography>
                    <Typography variant="h2">Help</Typography>
                    <Typography variant="button"> — свобода на час</Typography>
                  </Typography>
                </Box>
                <Typography component="p" sx={{ color: theme.palette.text.secondary, m: '8px 0' }} variant="caption">
                  Няня поиграет с ребенком, погуляет, встретит со школы, поможет с домашними заданиями,
                  <Typography variant="caption bold"> чтобы вы спокойно позанимались своими делами.</Typography>
                </Typography>
              </>
            ),
          },
        ]}
      />
    </Root>
  );
};
